import styled from "styled-components/macro";

import background from "./images/amex_bg.jpg";
import border from "./images/amex_border.png";
import face from "./images/amex_man.png";
import logo from "./images/amex_words.png";

export default function AmericanExpress() {
  return (
    <>
      <BackgroundPattern />
      <Border />
      <Face />
      <Logo src={logo} />
    </>
  );
}

const Logo = styled.div`
  position: absolute;
  top: 18%;
  left: 50%;
  width: 214px;
  height: 14px;
  max-width: calc(100% * 0.6);
  transform: translateX(-50%);
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

const Border = styled.div`
  background-image: url(${border});
  background-size: contain;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center center;
  top:0;
  bottom:0;
  left:0;
  right:0;
  background-size: 101% 101%;
  }
`;
const BackgroundPattern = styled.div`
  background-image: url(${background});
  background-size: cover;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 4px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const Face = styled.div`
  aspect-ratio: 122 / 153;
  width: 108px;
  max-width: calc(100% / 4);
  background-image: url(${face});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
`;
